(function () {

  /* ================== CONFIG / CONSTANTS ================== */

  const CARD_SELECTOR = ".t4s-product, .product-card, .prd, [data-product-card], [data-zapiet-card]";
  const PREDICTIVE_ITEM_SELECTOR = ".t4s-search-fullwidth__item, .t4s-mini-search__content .t4s-product, [data-results-search] .t4s-product";
  const SECTIONS_TO_OBSERVE = [
    ".id_recently_viewed",
    ".id_product-recommendations",
    ".product-recommendations",
    "#product-recommendations",
    "[data-section-type='product-recommendations']",
    ".t4s-mini-search__content",
    "[data-results-search]",
    ".predictive-search",
    ".search-results"
  ];

  const PAGE_PATH = window.location.pathname;
  const IS_RESTRICTED_PAGE = ["/cart", "/checkout", "/checkouts", "/thank_you"].some(p => PAGE_PATH.includes(p));
  if (IS_RESTRICTED_PAGE) return;

  const CARD_STATE_CACHE = new WeakMap();
  let zapietLock = false;
  const DEBUG = false;

  function logDebug(...args) {
    if (DEBUG) console.log("[COLLECTION BADGE]", ...args);
  }

  function lockZapietUpdates(temp = false, ms = 800) {
    zapietLock = true;
    if (temp) setTimeout(() => { zapietLock = false; }, ms);
  }

  /* ================== STYLES ================== */

  function injectBadgeStyles() {
    if (document.getElementById("zapiet-card-badges")) return;
    const style = document.createElement("style");
    style.id = "zapiet-card-badges";
    style.innerHTML = `
      ${CARD_SELECTOR} { position: relative; isolation: isolate; }
      .zapiet-badge {
        font-weight:500; padding:4px 6px; font-size:9px;
        position:absolute; top:8px; left:0px; border-radius:6px;
        z-index:10; pointer-events:none; color:#fff;
        min-width:64px; text-align:center; line-height:1;
        box-shadow:0 2px 6px rgba(0,0,0,.18);
      }
      .zapiet-disabled { opacity:.38; pointer-events:none; }
      .badge-available { background: rgba(0,207,131,.97); }
      .badge-sold-out { background: rgba(128,128,128,.92); }
      .badge-partially-available { background:#FF7A00; color:#fff; }
      .badge-unavailable { background: rgba(128,128,128,.92); }
      .badge-not-in-menu { background: rgba(100,100,100,.92); }
      .badge-loading { background: rgba(120,120,120,.5); color:#fff; }
      .badge-order-now {
        background: #8cc8ff;
        color: #00324d;
      }
      .no-click { pointer-events: none !important; cursor: default !important; }
    `;
    document.head.appendChild(style);
  }

  /* ================== BASIC HELPERS ================== */

  function isPredictiveCard(card) {
    if (!card || card.nodeType !== 1) return false;
    return !!(
      card.closest(".t4s-mini-search__content") ||
      card.closest("[data-results-search]") ||
      card.classList.contains("t4s-search-fullwidth__item")
    );
  }

  function ensureBadge(card) {
    if (!card || card.nodeType !== 1) return null;
    let badge = card.querySelector(".zapiet-badge");
    if (!badge) {
      badge = document.createElement("div");
      badge.className = "zapiet-badge badge-loading";
      badge.textContent = "…";
      try {
        card.prepend(badge);
      } catch (e) {
        card.insertBefore(badge, card.firstChild);
      }
    }
    return badge;
  }

  function setBadge(card, text, cls) {
    if (!card || card.nodeType !== 1) return;
    if (zapietLock && cls !== "badge-loading") return;
    const badge = ensureBadge(card);
    if (!badge) return;
    badge.textContent = text;
    badge.className = "zapiet-badge " + (cls || "badge-loading");
  }

  function paintLoadingBadges(scope = document) {
    const cards = scope.querySelectorAll ? scope.querySelectorAll(CARD_SELECTOR) : [];
    cards.forEach(c => ensureBadge(c));
  }

  function disableProduct(card, label) {
    if (isPredictiveCard(card)) return;
    card.classList.add("zapiet-disabled");

    const btn = card.querySelector("form[action*='/cart'] button[type='submit']");
    if (btn) {
      if (!btn.hasAttribute("data-original-label")) {
        btn.setAttribute("data-original-label", btn.innerText.trim());
      }
      btn.disabled = true;
      btn.innerText = label;
      btn.setAttribute("aria-disabled", "true");
    }

    const link = card.querySelector("a");
    if (link) {
      link.classList.add("no-click");
      link.style.pointerEvents = "none";
      link.style.cursor = "default";
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-hidden", "true");
    }
  }

  function enableProduct(card) {
    card.classList.remove("zapiet-disabled");

    const btn = card.querySelector("form[action*='/cart'] button[type='submit']");
    if (btn) {
      const original = btn.getAttribute("data-original-label") || "Add to Cart";
      btn.disabled = false;
      btn.innerText = original;
      btn.removeAttribute("aria-disabled");
    }

    const link = card.querySelector("a");
    if (link) {
      link.classList.remove("no-click");
      link.style.pointerEvents = "";
      link.style.cursor = "";
      link.removeAttribute("tabindex");
      link.removeAttribute("aria-hidden");
    }
  }

  /* ================== ZAPIET STATE ================== */

  function zapietState() {
    return {
      r: window.ZapietEats?.getSelectedRestaurant?.(),
      m: window.ZapietEats?.getSelectedMenu?.(),
      dRaw: window.ZapietEats?.getSelectedDate?.(),
      vm: window.ZapietWidgetConfig?.variant_metafields
    };
  }

  function toLocalISO(d) {
    if (!d) return null;
    try {
      // Luxon DateTime
      if (typeof d.toISODate === "function") {
        return d.toISODate();
      }
      let dt;
      if (typeof d === "string") {
        dt = new Date(d);
      } else if (d instanceof Date) {
        dt = d;
      } else if (d.date) {
        dt = new Date(d.date);
      } else {
        return null;
      }
      if (isNaN(dt)) return null;
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const day = String(dt.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    } catch (e) {
      logDebug("toLocalISO error", e);
      return null;
    }
  }

  function getInventoryDateISO() {
    const inv = window.ZapietEats?.getLocationInventoryDate?.();
    let d = toLocalISO(inv);
    if (d) return d;

    const dRaw = window.ZapietEats?.getSelectedDate?.();
    d = toLocalISO(dRaw);
    return d;
  }

  function getLocalTodayISO() {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  /* ================== SOLD OUT (TODAY INVENTORY ONLY) ================== */

  // For business rule: inventory is "TODAY INVENTORY" only.
  // For future days we ignore inventory toggles.
  function isVariantSoldOut(vm, rest, menu, dateISO, vid, checkInventory) {
    if (!checkInventory) return false; // ignore for future
    const vData = vm?.[vid];
    if (!vData) return false;

    const key = `limits.${rest}.${menu}.${dateISO}`;
    const inv = vData[key];
    if (!inv) return false;

    const toggledOff = inv?.toggled_off === true;
    const qtyZero = typeof inv?.remaining === "number" && inv.remaining <= 0;

    return toggledOff || qtyZero;
  }

  /* ================== DATE RESTRICTIONS ================== */

  function isVariantRestricted(restrictions, vid, dateIso, schedule) {
    if (!Array.isArray(restrictions)) return false;

    function scheduleSaysRestricted(dateToCheck) {
      if (!schedule || !schedule.specific_days) return false;
      const dt = new Date(dateToCheck);
      if (isNaN(dt)) return false;
      const month = dt.toLocaleString("en-US", { month: "short" }).toUpperCase();
      const day = String(dt.getDate()).padStart(2, "0");
      const year = dt.getFullYear();
      const zapKey = `${month}-${day}-${year}`;
      return !!schedule.specific_days[zapKey];
    }

    function checkDateAgainstRule(rule, checkDate) {
      if (String(rule.variant_id) !== String(vid)) return false;
      if (!rule.restriction_type || rule.restriction_type.toLowerCase() !== "deny") return false;

      if (Array.isArray(rule.restricted_dates) && rule.restricted_dates.includes(checkDate)) {
        return true;
      }

      if (rule.start_date && rule.end_date) {
        if (checkDate >= rule.start_date && checkDate <= rule.end_date) return true;
      }

      return false;
    }

    const exactMatch = restrictions.some(r => checkDateAgainstRule(r, dateIso));
    if (exactMatch) return true;

    if (scheduleSaysRestricted(dateIso)) return true;

    // small +/-1 safeguard around Zapiet quirk
    const dt = new Date(dateIso);
    if (!isNaN(dt)) {
      const dayBefore = new Date(dt);
      const dayAfter = new Date(dt);
      dayBefore.setDate(dt.getDate() - 1);
      dayAfter.setDate(dt.getDate() + 1);
      const isoBefore = toLocalISO(dayBefore);
      const isoAfter = toLocalISO(dayAfter);
      const beforeMatch = isoBefore && restrictions.some(r => checkDateAgainstRule(r, isoBefore));
      const afterMatch = isoAfter && restrictions.some(r => checkDateAgainstRule(r, isoAfter));
      if (beforeMatch || afterMatch) return true;
      if ((isoBefore && scheduleSaysRestricted(isoBefore)) || (isoAfter && scheduleSaysRestricted(isoAfter))) {
        return true;
      }
    }

    return false;
  }

  /* ================== VARIANT IDS FROM CARD ================== */

  function parseVariantIds(card) {
    let ids = [];
    let single = null;
    let shopifyAvailable = true;

    try {
      const inline = card.getAttribute("data-variant-ids");
      if (inline) ids = JSON.parse(inline.replace(/'/g, '"')).map(String);

      if (!ids.length) {
        const optsStr = card.getAttribute("data-product-options");
        if (optsStr) {
          const opts = JSON.parse(optsStr);
          if (opts?.VariantFirstID) single = String(opts.VariantFirstID);
          if (typeof opts?.available !== "undefined") shopifyAvailable = !!opts.available;
          if (Array.isArray(opts?.variants)) ids = opts.variants.map(v => String(v.id));
        }
      }
    } catch (e) {
      logDebug("parseVariantIds error", e);
    }

    return { ids: ids.length ? ids : (single ? [single] : []), shopifyAvailable };
  }

  function applyCardStateIfChanged(card, status, cls, disabledFlag) {
    const newState = `${status}|${cls}|${disabledFlag ? 1 : 0}`;
    const old = CARD_STATE_CACHE.get(card);
    if (newState === old) return;
    CARD_STATE_CACHE.set(card, newState);

    queueMicrotask(() => {
      setBadge(card, status, cls);
      if (disabledFlag) {
        disableProduct(card, status === "SOLD OUT TODAY" ? "SOLD OUT TODAY" : "UNAVAILABLE");
      } else {
        enableProduct(card);
      }
    });
  }

  /* ================== MAIN PER-CARD LOGIC ================== */

  function evaluateCard(card, vm, restrictions, schedule, rest, menu, dateISO, todayISO, menuSet) {
    if (!card || isPredictiveCard(card)) return;

    const { ids, shopifyAvailable } = parseVariantIds(card);
    if (!ids.length || !shopifyAvailable) {
      applyCardStateIfChanged(card, "UNAVAILABLE", "badge-unavailable", true);
      return;
    }

    // NOT IN MENU
    const allNotInMenu = ids.every(id => !menuSet.has(String(id)));
    if (allNotInMenu) {
      applyCardStateIfChanged(card, "NOT IN MENU", "badge-not-in-menu", true);
      return;
    }

    const isFuture = dateISO > todayISO;
    const checkInventory = !isFuture; // inventory only applies to today/past

    const sold = ids.map(id => isVariantSoldOut(vm, rest, menu, dateISO, id, checkInventory));
    const restr = ids.map(id => isVariantRestricted(restrictions, id, dateISO, schedule));

    const anySold = sold.some(Boolean);
    const allSold = sold.every(Boolean);
    const anyRestr = restr.some(Boolean);
    const allRestr = restr.every(Boolean);
    const anyAvailable = ids.some((_, i) => !sold[i] && !restr[i]);

    let status = "IN STOCK";
    let cls = "badge-available";
    let disabledFlag = false;

    if (isFuture) {
      // FUTURE: ignore SOLD OUT inventory, only restrictions
      if (allRestr) {
        status = "UNAVAILABLE";
        cls = "badge-unavailable";
        disabledFlag = true;
      } else if (anyRestr && anyAvailable) {
        status = "LIMITED";
        cls = "badge-partially-available";
        disabledFlag = false;
      } else {
        status = "IN STOCK";
        cls = "badge-available";
      }
    } else {
      // TODAY (or past): use inventory + restrictions
      if (allSold) {
        status = "SOLD OUT TODAY";
        cls = "badge-sold-out";
        disabledFlag = true;
      } else if (allRestr) {
        status = "UNAVAILABLE";
        cls = "badge-unavailable";
        disabledFlag = true;
      } else if ((anySold || anyRestr) && anyAvailable) {
        status = "LIMITED";
        cls = "badge-partially-available";
        disabledFlag = false;
      } else {
        status = "IN STOCK";
        cls = "badge-available";
      }
    }

    applyCardStateIfChanged(card, status, cls, disabledFlag);
  }

  /* ================== EVALUATE ALL CARDS ================== */

  function evaluateAllCards(scope = document) {
    const cards = scope.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    const { r, m, dRaw, vm } = zapietState();
    if (!r || !m || !vm) {
      lockZapietUpdates(true, 1800);
      paintLoadingBadges(scope);
      setTimeout(() => waitForZapietEats(() => evaluateAllCards(scope)), 3000);
      return;
    }

    if (zapietLock) return;

    const selectedDate = getInventoryDateISO();
    const todayISO = getLocalTodayISO();
    logDebug("Zapiet State → RESTO:", r?.id, "MENU:", m?.id, "DATE:", selectedDate, "TODAY:", todayISO);

    // If NO DATE selected → ORDER NOW for all cards
    if (!selectedDate) {
      cards.forEach(card => {
        applyCardStateIfChanged(card, "ORDER NOW", "badge-order-now", false);
      });
      return;
    }

    const deliveryOption = window.ZapietEats.getDeliveryOption?.() === "pickup"
      ? "store_pickup"
      : "local_delivery";

    const menuCfg = m?.config?.[deliveryOption] || {};
    const restrictions = menuCfg.product_date_restrictions || [];
    const schedule = menuCfg.schedule || null;

    const menuIds = [];
    m?.menu_sections?.forEach(section => {
      section?.menu_section_items?.forEach(item => {
        if (item?.product?.variant_id) {
          menuIds.push(String(item.product.variant_id));
        }
      });
    });
    const menuSet = new Set(menuIds);

    cards.forEach(card =>
      evaluateCard(card, vm, restrictions, schedule, r.id, m.id, selectedDate, todayISO, menuSet)
    );
  }

  /* ================== WAIT FOR ZAPIET INIT ================== */

  function waitForZapietEats(cb, tries = 0) {
    if (window.ZapietEats?.getSelectedMenu && window.ZapietWidgetConfig?.variant_metafields) {
      cb();
    } else if (tries < 80) {
      setTimeout(() => waitForZapietEats(cb, tries + 1), 250);
    } else {
      evaluateAllCards();
    }
  }

  /* ================== OBSERVERS / EVENTS ================== */

  let rafToken = null;
  let debounceLock = false;

  function scheduleEvaluate() {
    if (debounceLock) return;
    debounceLock = true;
    if (rafToken) cancelAnimationFrame(rafToken);
    rafToken = requestAnimationFrame(() => {
      debounceLock = false;
      evaluateAllCards();
    });
  }

  function addObservers() {
    document.addEventListener("zapieteats:ready", scheduleEvaluate);
    document.addEventListener("zapieteats:change", scheduleEvaluate);
    document.addEventListener("zapieteats:refresh", scheduleEvaluate);

    setInterval(() => {
      const hour = new Date().getHours();
      if (hour === 0 || hour === 7) scheduleEvaluate();
    }, 1800000);

    const observed = new WeakSet();
    function attach(container) {
      if (observed.has(container)) return;
      const o = new MutationObserver(() => scheduleEvaluate());
      o.observe(container, { childList: true, subtree: true });
      observed.add(container);
    }

    function attachToExisting() {
      SECTIONS_TO_OBSERVE.forEach(sel => {
        document.querySelectorAll(sel).forEach(c => attach(c));
      });
      attach(document.body);
    }

    attachToExisting();

    let scans = 0;
    const scanner = setInterval(() => {
      attachToExisting();
      scheduleEvaluate();
      scans++;
      if (scans >= 8) clearInterval(scanner);
    }, 2500);
  }

  /* ================== PREDICTIVE SEARCH BADGES ================== */

  function predictiveBadgeHtmlFromStatus(status) {
    if (!status) return "";
    const s = String(status).toUpperCase();
    switch (s) {
      case "UNAVAILABLE": return `<span class="zapiet-badge badge-unavailable">Unavailable</span>`;
      case "AVAILABLE": return `<span class="zapiet-badge badge-available">Available</span>`;
      case "DATE_RESTRICTED": return `<span class="zapiet-badge badge-partially-available">Ready Tomorrow</span>`;
      case "LIMITED": return `<span class="zapiet-badge badge-partially-available">Limited</span>`;
      case "SOLD_OUT": return `<span class="zapiet-badge badge-sold-out">Sold Out</span>`;
      default: return "";
    }
  }

  function applyPredictiveBadges(scope = document) {
    const items = scope.querySelectorAll(PREDICTIVE_ITEM_SELECTOR);
    if (!items.length) return;

    items.forEach(item => {
      const card = item.classList.contains("t4s-search-fullwidth__item")
        ? item
        : (item.querySelector(".t4s-search-fullwidth__item") || item);

      if (!card) return;

      let box = card.querySelector(".t4s-products-availability-badge");
      if (!box) {
        box = document.createElement("div");
        box.className = "t4s-products-availability-badge";
        card.prepend(box);
      }

      const json = card.querySelector('script[type="application/json"]');
      let data = null;

      if (json) {
        try {
          data = JSON.parse(json.textContent.trim());
        } catch (e) { /* ignore */ }
      } else {
        const a = card.getAttribute("data-zapiet-availability") || card.getAttribute("data-availability");
        if (a) data = { zapietAvailability: a };
      }

      const avail = data?.zapietAvailability || data?.availability || card.getAttribute("data-zapiet-availability");
      const html = predictiveBadgeHtmlFromStatus(avail);
      box.innerHTML = html || "";
    });
  }

  function observePredictive() {
    applyPredictiveBadges();

    const observer = new MutationObserver(mutations => {
      let touched = false;
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(PREDICTIVE_ITEM_SELECTOR)) touched = true;
          if (node.querySelector?.(PREDICTIVE_ITEM_SELECTOR)) touched = true;
        });
      });
      if (touched) applyPredictiveBadges();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ================== INIT ================== */

  function init() {
    injectBadgeStyles();
    paintLoadingBadges(document);
    waitForZapietEats(() => {
      evaluateAllCards();
      addObservers();
      observePredictive();
      setTimeout(() => { evaluateAllCards(); applyPredictiveBadges(); }, 1400);
      setTimeout(() => { evaluateAllCards(); applyPredictiveBadges(); }, 3200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
